/* ============================================
   lp-popup-form.js
   Popup de formulario externo (Clientify, Klaviyo, …).

   Autónomo: trigger + cookie de frecuencia + carga perezosa del embed.
   No depende del motor sys-popup-lapeau.

   El embed vive en un <template> (inerte: el navegador lo parsea pero no lo
   ejecuta ni descarga) y solo se inyecta en un iframe srcdoc al abrir el popup.
   Dentro del iframe el <script> vuelve a ser parser-inserted en un documento
   nuevo, así que los embeds basados en document.write funcionan y su peor caso
   queda encerrado ahí en vez de borrar la tienda.
   ============================================ */
(function () {
  'use strict';

  var DOC_HEAD =
    '<!doctype html><html><head><meta charset="utf-8">' +
    '<meta name="viewport" content="width=device-width, initial-scale=1">' +
    '<base target="_parent"></head><body style="margin:0">';
  var DOC_TAIL = '</body></html>';

  function readCookie(name) {
    var parts = ('; ' + document.cookie).split('; ' + name + '=');
    return parts.length === 2 ? parts.pop().split(';').shift() : null;
  }

  function writeCookie(name, value, days) {
    var d = new Date();
    d.setTime(d.getTime() + days * 24 * 60 * 60 * 1000);
    document.cookie = name + '=' + value + ';expires=' + d.toUTCString() + ';path=/;SameSite=Lax';
  }

  class LpPopupForm extends HTMLElement {
    connectedCallback() {
      if (this._booted) return;
      this._booted = true;

      this.modal = this.querySelector('hdt-modal');
      this.wrap = this.querySelector('[data-lp-external-wrap]');
      this.tpl = this.querySelector('[data-lp-external-form]');
      this.frame = this.querySelector('[data-lp-external-frame]');
      if (!this.modal || !this.wrap || !this.tpl || !this.frame) return;

      this.cookieKey = 'theme4:lppopupform:' + this.dataset.sectionId;
      this.dayNext = parseInt(this.dataset.dayNext, 10) || 7;

      this._fill = this.fill.bind(this);
      this.modal.addEventListener('dialog:beforeOpen', this._fill);
      this.modal.addEventListener('dialog:afterOpen', () => {
        if (this._syncHeight) this._syncHeight();
      });

      // Editor: abrir al seleccionar esta sección (y solo esta).
      if (window.Shopify && Shopify.designMode) {
        var sectionEl = this.closest('.shopify-section');
        document.addEventListener('shopify:section:select', (e) => {
          if (e.target === sectionEl) this.open();
        });
        document.addEventListener('shopify:section:deselect', (e) => {
          if (e.target === sectionEl) this.modal.removeAttribute('open');
        });
        return;
      }

      if (readCookie(this.cookieKey) === 'shown') return;

      this.modal.addEventListener('dialog:afterClose', () => {
        this.remember();
        this.teardownTrigger();
      });

      this.setupTrigger();
    }

    setupTrigger() {
      if (this.dataset.after === 'scroll') {
        var threshold = parseInt(this.dataset.scrollDelay, 10) || 800;
        this._onScroll = () => {
          if (window.scrollY > threshold) {
            this.open();
            this.teardownTrigger();
          }
        };
        window.addEventListener('scroll', this._onScroll, { passive: true });
      } else {
        var delay = (parseFloat(this.dataset.timeDelay) || 3) * 1000;
        this._timer = setTimeout(() => this.open(), delay);
      }
    }

    teardownTrigger() {
      if (this._timer) clearTimeout(this._timer);
      if (this._onScroll) window.removeEventListener('scroll', this._onScroll);
    }

    open() {
      this.modal.setAttribute('open', '');
      // Respaldo: si <hdt-modal> no emitiera dialog:beforeOpen, el embed igual carga.
      this.fill();
    }

    remember() {
      writeCookie(this.cookieKey, 'shown', this.dayNext);
    }

    fill() {
      if (this._filled) return;
      var code = this.tpl.innerHTML.trim();
      if (!code) return;
      this._filled = true;

      this.frame.addEventListener('load', () => this.bindHeight());
      this.frame.srcdoc = DOC_HEAD + code + DOC_TAIL;
    }

    /* Altura.

       Modo "fixed": el alto lo manda el merchant. Necesario para embeds que no
       tienen altura natural — p. ej. un formulario de Clientify configurado
       como "popup con botón" se renderiza como overlay `position:fixed` con el
       form en `absolute`, así que su documento siempre mide lo que mida el
       marco y auto-medirlo es circular.

       Modo "auto": se sigue la altura declarada por el embed. Correcto para
       embeds normales en flujo (los que Clientify llama "embebido").

       Se probó medir el contenido real descartando wrappers de cobertura; no es
       robusto (elementos anclados abajo, como el badge de reCAPTCHA, cuyos
       hijos son `static` bajo un padre `fixed`, reintroducen la circularidad).
       Un alto explícito es predecible y no se rompe solo. */
    bindHeight() {
      var doc = this.frame.contentDocument;
      if (!doc || !doc.body) return;

      if (this.dataset.heightMode === 'fixed') {
        this.frame.style.height = (parseInt(this.dataset.formHeight, 10) || 520) + 'px';
        this._syncHeight = function () {};
        return;
      }

      var minH = parseInt(this.dataset.formHeight, 10) || 0;
      var pending = false;

      var sync = () => {
        pending = false;
        var h = doc.documentElement.scrollHeight || doc.body.scrollHeight;
        if (!h) return;
        this.frame.style.height = Math.ceil(Math.max(h, minH)) + 'px';
      };

      this._syncHeight = () => {
        if (pending) return;
        pending = true;
        requestAnimationFrame(sync);
      };

      // El embed monta en asíncrono: ResizeObserver cubre el cambio de caja y
      // MutationObserver el montaje de nodos que caen fuera de ella.
      if (window.ResizeObserver) new ResizeObserver(this._syncHeight).observe(doc.body);
      if (window.MutationObserver) {
        new MutationObserver(this._syncHeight).observe(doc.body, { childList: true, subtree: true });
      }
      this._syncHeight();
    }

    disconnectedCallback() {
      this.teardownTrigger();
    }
  }

  if (!customElements.get('lp-popup-form')) {
    customElements.define('lp-popup-form', LpPopupForm);
  }
})();
